var _a;
export var DistanceUnit;
(function (DistanceUnit) {
    DistanceUnit["KM"] = "km";
    DistanceUnit["M"] = "m";
    DistanceUnit["MI"] = "mi";
    DistanceUnit["FT"] = "ft";
})(DistanceUnit || (DistanceUnit = {}));
var TO_METERS = (_a = {},
    _a[DistanceUnit.KM] = 1000,
    _a[DistanceUnit.M] = 1,
    _a[DistanceUnit.MI] = 1609.34,
    _a[DistanceUnit.FT] = 0.3048,
    _a);
export var convertDistance = function (source, target, options) {
    var multiplier = source.unit === target ? 1 : TO_METERS[source.unit] / TO_METERS[target];
    var converted = source.value * multiplier;
    var rounded = (options === null || options === void 0 ? void 0 : options.precision) === undefined ? converted : parseFloat(converted.toFixed(options === null || options === void 0 ? void 0 : options.precision));
    return { value: rounded, unit: target };
};
